module.exports = __webpack_public_path__ + "img/80.9.TU.f34703bd.png";